import React, { useState } from "react";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";

const Paymentbox = ({ dateWiseData, loading }) => {
  const paymentData = [
    {
      id: 1,
      title: "סה”כ התשלומים לביטוחי",
      type: "אלמנטרים",
      amounts: {
        monthly: dateWiseData?.monthlyCB + dateWiseData?.yearlyCB / 12,
        yearly: dateWiseData?.yearlyCB + dateWiseData?.monthlyCB * 12,
      },
    },
    {
      id: 2,
      title: "סה”כ התשלומים לביטוחי",
      type: "חיים ובריאות",
      amounts: {
        monthly: dateWiseData?.monthlyHL + dateWiseData?.yearlyHL / 12,
        yearly: dateWiseData?.yearlyHL + dateWiseData?.monthlyHL * 12,
      },
    },
  ];

  const [selectedPeriods, setSelectedPeriods] = useState(
    Object.fromEntries(paymentData.map(({ id }) => [id, "monthly"]))
  );

  const handlePeriodChange = (id, period) => {
    setSelectedPeriods((prev) => {
      return { ...prev, [id]: period };
    });
  };

  return (
    <div className="payment-info-main d-flex">
      {paymentData.map(({ id, title, type, amounts }) => {
        const selectedPeriod = selectedPeriods[id];
        return (
          <div
            key={`${id}-${selectedPeriod}`}
            className="payment-info-box d-flex justify-content-between"
          >
            <div className="box-title">
              <span>
                {title} <strong>{type}</strong>
              </span>
              {loading ? (
                <h2>
                  <Skeleton
                    variant="rectangular"
                    width="130px"
                    height="30px"
                    animation="wave"
                    sx={{ backgroundColor: "#F3F3F4", borderRadius: 1 }}
                  />
                </h2>
              ) : (
                <h2>
                  ₪{Math.floor(amounts[selectedPeriod] || 0).toLocaleString()}
                </h2>
              )}
            </div>
            <div className="btn-group d-flex flex-column">
              <Button
                size="large"
                className="btn"
                variant={
                  selectedPeriod === "monthly" ? "contained" : "outlined"
                }
                onClick={() => handlePeriodChange(id, "monthly")}
              >
                חודש
              </Button>
              <Button
                size="large"
                className="btn"
                variant={selectedPeriod === "yearly" ? "contained" : "outlined"}
                onClick={() => handlePeriodChange(id, "yearly")}
              >
                שנה
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Paymentbox;
